import React from 'react';

import {
  EnterpriseSpecification,
  EnterpriseSpecsList,
} from 'modules/enterprise';
import { SEO } from 'main/components';

import f405SlideFirst from '../../../main/assets/images/enterprise/f405-slider-first.webp';
import f405SlideSecond from '../../../main/assets/images/enterprise/f405-slider-second.webp';
import f405SlideThird from '../../../main/assets/images/enterprise/f405-slider-third.webp';
import f405SlideFourth from '../../../main/assets/images/enterprise/f405-slider-fourth.webp';
import f405SlideFifth from '../../../main/assets/images/enterprise/f405-slider-fifth.webp';
import f405SlideSixth from '../../../main/assets/images/enterprise/f405-slider-sixth.webp';
import fourInOneSlideFirst from '../../../main/assets/images/enterprise/3030-esc-slider-first.webp';
import fourInOneSlideSecond from '../../../main/assets/images/enterprise/3030-esc-slider-second.webp';
import fourInOneSlideThird from '../../../main/assets/images/enterprise/3030-esc-slider-third.webp';
import fpvProSlideFirst from '../../../main/assets/images/enterprise/fpv-pro-slider-first.webp';
import fpvProSlideSecond from '../../../main/assets/images/enterprise/fpv-pro-slider-second.webp';
import fpvProSlideThird from '../../../main/assets/images/enterprise/fpv-pro-slider-third.webp';
import fpvProSlideFourth from '../../../main/assets/images/enterprise/fpv-pro-slider-fourth.webp';
import fpvProSlideFifth from '../../../main/assets/images/enterprise/fpv-pro-slider-fifth.webp';
import fpvProSlideSixth from '../../../main/assets/images/enterprise/fpv-pro-slider-sixth.webp';
import fpvProSlideSeventh from '../../../main/assets/images/enterprise/fpv-pro-slider-seventh.webp';
import fpvProSlideEight from '../../../main/assets/images/enterprise/fpv-pro-slider-eight.webp';
import fpvProSlideNinth from '../../../main/assets/images/enterprise/fpv-pro-slider-ninth.webp';

const fcSpecsData = {
  column1: [
    {
      subtitle: 'Processor',
      descriptions: ['STM32F405'],
    },
    {
      subtitle: 'FIRMWARE',
      descriptions: ['Betaflight & iNav support'],
    },
    {
      subtitle: 'IMU',
      descriptions: ['ICM-42688'],
    },
    {
      subtitle: 'LAYOUT',
      descriptions: ['30x30mm single-sided'],
    },
  ],
  column2: [
    {
      subtitle: 'CONNECTORS',
      descriptions: ['Locking JST-GH, USB-C'],
    },
    {
      subtitle: 'POWER',
      descriptions: ['Twin 2A switching regulators (5V and 10V)'],
    },
    {
      subtitle: 'MEMORY',
      descriptions: ['16MByte serial flash'],
    },
    {
      subtitle: 'MOTOR OUTPUTS',
      descriptions: ['4 or 8'],
    },
  ],
  column3: [
    {
      subtitle: 'VIDEO',
      descriptions: ['Two camera inputs (switchable via R/C), Standard OSD'],
    },
    {
      subtitle: 'SENSORS',
      descriptions: ['Onboard barometric altimeter & beeper'],
    },
    {
      subtitle: 'INTERFACES',
      descriptions: [
        'SIK radio, GPS/Magnetometer, Payload connector with GHST passthrough',
      ],
    },
    {
      subtitle: 'COMPLIANCE',
      descriptions: ['NDAA compliant, designed & manufactured in the EU'],
    },
  ],
};

const escSpecsData = {
  column1: [
    {
      subtitle: 'TYPE',
      descriptions: ['4-in-1 Brushless ESC'],
    },
    {
      subtitle: 'CURRENT RATING',
      descriptions: ['70A Continuous (80A Burst for 10s)'],
    },
    {
      subtitle: 'VOLTAGE',
      descriptions: ['3S-6S LiPo Support'],
    },
  ],
  column2: [
    {
      subtitle: 'FIRMWARE',
      descriptions: ['AM32'],
    },
    {
      subtitle: 'PROTOCOLS',
      descriptions: ['DShot 300/600/1200, Bi-directional DShot'],
    },
    {
      subtitle: 'MOUNTING',
      descriptions: ['30x30mm'],
    },
  ],
  column3: [
    {
      subtitle: 'WEIGHT',
      descriptions: ['~28g'],
    },
    {
      subtitle: 'INCLUDED',
      descriptions: [
        'FC Connection Cable, 4x Shock-absorbing Silicone Grommets',
      ],
    },
    {
      subtitle: 'COMPLIANCE',
      descriptions: ['NDAA compliant, designed & manufactured in the EU'],
    },
  ],
};

const fpvProSpecsData = {
  column1: [
    {
      subtitle: 'DISPLAY',
      descriptions: ['1280 x 960 Pixels'],
    },
    {
      subtitle: 'FIELD OF VIEW',
      descriptions: ['37° Diagonal'],
    },
    {
      subtitle: 'ASPECT RATIO',
      descriptions: ['4:3 Native, 16:9 (720p) support'],
    },
    {
      subtitle: 'IPD RANGE',
      descriptions: ['56-74mm'],
    },
  ],
  column2: [
    {
      subtitle: 'FOCUS ADJUST',
      descriptions: ['-4D to +4D'],
    },
    {
      subtitle: 'POWER INPUT',
      descriptions: ['6-25V DC (2S-6S Li-Ion)'],
    },
    {
      subtitle: 'CONNECTIVITY',
      descriptions: [
        'Single Multipole Lemo (Analog + HDMI), HDMI In, Composite In, Audio Out, Mic In',
      ],
    },
    {
      subtitle: 'DVR',
      descriptions: ['1280x960 @ 50/60fps, H.264 MP4 with upscaling'],
    },
  ],
  column3: [
    {
      subtitle: 'CONSTRUCTION',
      descriptions: ['Ruggedized, IP53 water-resistant'],
    },
    {
      subtitle: 'DIMENSIONS',
      descriptions: ['177 x 107 x 72mm'],
    },
    {
      subtitle: 'WEIGHT',
      descriptions: ['256g'],
    },
    {
      subtitle: 'COMPLIANCE',
      descriptions: ['NDAA compliant, designed & manufactured in the EU'],
    },
  ],
};

const f405SlideImages = [
  f405SlideFirst,
  f405SlideSecond,
  f405SlideThird,
  f405SlideFourth,
  f405SlideFifth,
  f405SlideSixth,
];

const esc3030SliderImages = [
  fourInOneSlideFirst,
  fourInOneSlideSecond,
  fourInOneSlideThird,
];

const fpvProSliderImages = [
  fpvProSlideFirst,
  fpvProSlideSecond,
  fpvProSlideThird,
  fpvProSlideFourth,
  fpvProSlideFifth,
  fpvProSlideSixth,
  fpvProSlideSeventh,
  fpvProSlideEight,
  fpvProSlideNinth,
];

export const Enterprise = () => {
  return (
    <>
      <SEO seoTitle="Enterprise - NDAA Compliant components for FPV drones - Orqa" />
      <section className="enterprise-section">
        <div className="enterprise-title-section">
          <h1 className="enterprise-subtitle">
            High performance, secure and affordable
          </h1>
          <h2 className="enterprise-title">
            NDAA Compliant components for FPV quadcopters
          </h2>
        </div>
        <EnterpriseSpecification
          subtitle="UNCOMPROMISING RELIABILITY"
          title="f405 3030 fc"
          description="Eliminate a key point of failure - Orqa’s flight controller uses secure, lockable JST-GH connectors instead of solder pads for a fast, clean build. Designed and manufactured in the EU, it’s the reliable core for missions that can’t afford to fail."
          buttons={{
            buyNow: {
              text: 'buy now',
              url:
                'https://shop.orqafpv.com/products/orqa-dream-5-rtf-hd-ready',
            },
            moreInfo: {
              text: 'get more info',
              url: '/contact?product=f405-3030-fc',
            },
          }}
          images={f405SlideImages}
          inverted={false}
        />
        <EnterpriseSpecsList columns={fcSpecsData} />
        <EnterpriseSpecification
          subtitle="FLAWLESS POWER DELIVERY"
          title="4IN1 3030 ESC"
          description="Handle extreme loads with confidence. This 70A 4-in-1 ESC delivers smooth, reliable power for the most demanding motors. Designed and manufactured in the EU, it includes a direct-connect cable for the Orqa F405 FC for a perfect plug-and-play stack."
          buttons={{
            buyNow: {
              text: 'buy now',
              url:
                'https://shop.orqafpv.com/products/orqa-dream-5-rtf-hd-ready',
            },
            moreInfo: {
              text: 'get more info',
              url: '/contact?product=4in1-3030-esc',
            },
          }}
          images={esc3030SliderImages}
          inverted={true}
        />
        <EnterpriseSpecsList columns={escSpecsData} />
        <EnterpriseSpecification
          subtitle="MISSION-CRITICAL CLARITY"
          title="FPV.Pro"
          description="Engineered for the professional operator. The FPV.Pro features a rugged, IP53-rated design, simplified glove-operable controls, and a single Lemo connector for flawless connection. Designed and made in the EU, it's built for high-stakes missions."
          buttons={{
            moreInfo: {
              text: 'get more info',
              url: '/contact?product=fpv-pro',
            },
          }}
          images={fpvProSliderImages}
          inverted={false}
        />
        <EnterpriseSpecsList columns={fpvProSpecsData} />
      </section>
    </>
  );
};
